import type { UserRole } from '@/types/auth';

export const USER_ROLES = {
  EMPLOYEE: 'EMPLOYEE',
  LEADER: 'LEADER',
  ADMIN: 'ADMIN',
} as const satisfies Record<string, UserRole>;

/** 数据库存储用；界面仅区分系统管理员与普通用户 */
export const ROLE_LABELS: Record<UserRole, string> = {
  EMPLOYEE: '普通用户',
  LEADER: '普通用户',
  ADMIN: '系统管理员',
};

export function formatUserRole(role: UserRole): string {
  return role === USER_ROLES.ADMIN ? ROLE_LABELS.ADMIN : ROLE_LABELS.EMPLOYEE;
}
